<template>
  <el-dialog
    title="选择接收人"
    :visible.sync="dialogVisible"
    width="70%"
    @close="closeDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
  >
    <div class="employee-select-container">
      <div class="search-area">
        <el-form :inline="true" :model="searchForm" size="small">
          <el-form-item label="姓名">
            <el-input v-model="searchForm.name" placeholder="请输入姓名" style="width: 150px;" clearable></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="searchForm.phone" placeholder="请输入手机号" style="width: 150px;" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="table-area">
        <el-table
          size="small"
          :data="employeeList"
          border
          style="width: 100%"
          v-loading="loading"
          @selection-change="handleSelectionChange"
          ref="employeeTable"
        >
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column prop="name" label="姓名" width="100" align="center"></el-table-column>
          <el-table-column prop="phone" label="手机号" width="130" align="center"></el-table-column>
          <el-table-column prop="organization_name" label="组织" width="150" align="center"></el-table-column>
          <el-table-column prop="employee_identity" label="员工身份" width="120" align="center">
            <template slot-scope="scope">
              {{ scope.row.employee_identity === '1' ? '正式员工' : scope.row.employee_identity === '2' ? '劳务派遣' : scope.row.employee_identity === '3' ? '外包人员' : '其他' }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-area">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="currentPage"
          :page-size="pageSize"
          :total="total"
          layout="total, prev, pager, next"
        ></el-pagination>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="confirmSelect" :loading="submitLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import AfuncApi from '@/api/afunc.js';

export default {
  name: 'SelectEmployee',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    selectedIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      submitLoading: false,
      employeeList: [],
      selectedEmployees: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      searchForm: {
        name: '',
        phone: '',
        status: 1
      }
    };
  },
  watch: {
    visible: {
      handler(newVal) {
        this.dialogVisible = newVal;
        if (newVal) {
          this.getEmployeeList();
        }
      },
      immediate: true
    },
    dialogVisible(newVal) {
      if (!newVal) {
        this.$emit('update:visible', false);
      }
    }
  },
  methods: {
    getEmployeeList() {
      let self = this;
      self.loading = true;
      let params = {
        ...self.searchForm,
        page: self.currentPage,
        list_rows: self.pageSize
      };
      AfuncApi.call({
        model: 'ma_yg',
        action: 'getList',
        ...params
      })
        .then(data => {
          self.loading = false;
          self.employeeList = data.data.list.data;
          self.total = data.data.list.total;
          self.$nextTick(() => {
            self.toggleSelection();
          });
        })
        .catch(error => {
          self.loading = false;
        });
    },

    handleSearch() {
      this.currentPage = 1;
      this.getEmployeeList();
    },

    resetSearch() {
      this.searchForm = {
        name: '',
        phone: '',
        status: 1
      };
      this.currentPage = 1;
      this.getEmployeeList();
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getEmployeeList();
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.getEmployeeList();
    },

    handleSelectionChange(selection) {
      this.selectedEmployees = selection;
    },

    toggleSelection() {
      this.$refs.employeeTable.clearSelection();
      if (this.selectedIds && this.selectedIds.length > 0) {
        this.employeeList.forEach(row => {
          if (this.selectedIds.includes(row.ma_yg_id)) {
            this.$refs.employeeTable.toggleRowSelection(row, true);
          }
        });
      }
    },

    closeDialog() {
      this.dialogVisible = false;
    },

    confirmSelect() {
      this.$emit('confirm', this.selectedEmployees);
      this.dialogVisible = false;
    }
  }
};
</script>

<style scoped>
.employee-select-container {
  min-height: 400px;
}

.search-area {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.table-area {
  margin-bottom: 20px;
}

.pagination-area {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}

.dialog-footer {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/xieyi/part/SelectEmployee.vue